import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValues from "@store/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface TypographyNoResultsParameters {
    separated?: boolean;
    spaced?: boolean;
}

export const typographyGetNoResultsProps = (
    parameters: TypographyNoResultsParameters = {},
): TypographyPresentationProps => {
    const { separated, spaced } = parameters;

    return {
        variant: "p",
        css: css`
            margin: 0;

            ${({ theme }) => {
                const output = [];

                if (separated) {
                    output.push(css`
                        border-top: ${pxToRem(1)} solid ${getColor("common.border")};
                    `);
                }

                if (separated || spaced) {
                    output.push(css`
                        padding-top: ${theme.design.typography.spacing.base};
                    `);
                }

                return output;
            }}
        `,
    };
};

export const typographyGetNoResultsAltProps = (
    parameters: TypographyNoResultsParameters = {},
): TypographyPresentationProps => {
    const { separated, spaced } = parameters;

    return {
        forwardAs: "p",
        variant: "h5",
        css: css`
            margin: 0;
            text-align: center;

            ${() => {
                const output = [];

                if (separated) {
                    output.push(css`
                        border-top: ${pxToRem(1)} solid ${getColor("common.border")};
                    `);
                }

                if (separated || spaced) {
                    output.push(css`
                        ${breakpointValues(pxToRemArray([20, 30, 40, null, 50]), "padding-top")}
                    `);
                }

                return output;
            }}
        `,
    };
};
